import inputTypeRadioGroup from '@/view/formActivity/editorFormToolConfig/inputTypeRadioGroup.vue'
export const config = {
  propsName: 'renderProps',
  name: 'formItemConfig',
  type: 'homeConfig',
  icon: 'el-icon-setting',
  cnName: '表单项通用配置',
  tooltip: '表单项通用配置',
  base: {  
  },
  props: [
    {
      type: () => import('@/weappTmps/comps/margin/index.vue'),
      cmpPath: '/comps/margin/index.vue',
      key: 'formItemMargin',
      bind: {
        label: '表单项外边距',
        'quote-type': [0, '/', 0, '/'],
        quoteKey:'margin'
      },
      on: {},
      value: [0, 0, 0, 0]
    },
    {
      type: 'el-input',
      key: 'fontSize',
      bind: {
        label: '表单项名称字体大小',
        placeholder: '请输入字号'
      },
      value: ''
    },
    {
      tooltip: '字体粗细',
      type: () => import('@/weappTmps/comps/fontWeight/index.vue'),
      cmpPath: '/comps/fontWeight/index.vue',
      key: 'fontWeight',
      bind: {
        // label: '排列方式',
      },
      on: {},
      value: '1'
    },
    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/color/index.vue'),
      cmpPath: '/comps/color/index.vue',
      key: 'formItemColor',
      bind: {
        label: '控件名称颜色',
        quoteKey:'color'
      },
      on: {},
      value: null
    },
    {
      type: 'el-input',
      key: 'itemTitleToCmpDistance',
      bind: {
        label: '表单项名称到表单控间距',
        placeholder: '请输入间距'
      },
      value: ''
    },
    {
      type: inputTypeRadioGroup,      
      key: 'inputStyle',
      bind: {
        label: '输入框控件样式',
      },
      value: {
        itemLayout: null,
        inputItemBorderColor:null,
        inputItemBottomLineColor:null,
        inputBackgroundColor:null,
      }
    },
    // ``````````````````````
    
    
  ]
}
